import { z } from 'zod';

export const categorySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  parentId: z.string().optional(),
  groupType: z.enum(['salary', 'taxes', 'operational', 'capital', 'other']),
});

export type CategoryFormData = z.infer<typeof categorySchema>;
